import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps(_ctx.$attrs, {
    type: _ctx.visiblePassword ? 'text' : 'password',
    "append-inner-icon": _ctx.visiblePassword ? 'mdi-eye-off' : 'mdi-eye',
    "onClick:appendInner": _cache[0] || (_cache[0] = ($event: any) => (_ctx.visiblePassword = !_ctx.visiblePassword))
  }), null, 16, ["type", "append-inner-icon"]))
}